export const enum Protocol {
  http = 'http://',
  https = 'https://',
}

export const prefix = Protocol.https;

export const EXTERNAL_URL_STAGE = {
  pague_la: 'https://app.dev.pague.la',
  pague_la_checkout: 'https://novo.pague.la',
  sign_view: 'https://assine.actuar.com',
  hotsite_domain: 'stage.novo.actuar.com',
  link_shortener_actuar: 'https://link.actuar.com/',
  link_shortener_ediz: 'https://link.ediz.com.br/',
  registration_app: 'https://registration-app-stage.pages.dev',
};

export const APP_URL_STAGE = {
  accounts: prefix + 'accounts.stage.actuar.dev',
  actuar_app: prefix + 'app.stage.actuar.dev',
  legacy_app: prefix + 'app.actuar.com',
  treino_app: prefix + 'treino.stage.actuar.dev',
  actuar_sign: prefix + 'sign.stage.actuar.dev',
  afig_app: prefix + 'app.afig.stage.actuar.dev',
  actuar_acesso: prefix + 'acesso.stage.actuar.dev',
  facilfit_app: prefix + 'app.facilfit.stage.actuar.dev',
  face_detection_app: prefix + 'facialid.stage.actuar.com',
  ediz_app: prefix + 'app.stage.actuar.dev',
  tickou_app: prefix + 'app.stage.tickou.com.br',
  live_pickup_app: prefix + 'livepickup.ediz.com.br',
  ediz_family_app: prefix + 'app.familia.stage.ediz.com.br',
  live_access_app: prefix + 'liveaccess.stage.actuar.dev',
  paguela_v2_app: prefix + 'novo.pague.la',
};

export const API_STAGE_ACTUAR = {
  // Servidores de loopback dos clientes desktop, na máquina do operador. Iguais
  // nos cinco ambientes: a estação é a do operador em todos eles.
  // Contrato: accessedge/docs/integracoes/handoff-front-status-local.md
  edge_desk_status: 'http://localhost:63317/desk/status',
  access_desk_status: 'http://localhost:63318/desk/status',
  print_agent_status: 'http://localhost:63319/printagent/status',
  edge_desk_release:
    'https://prd-desktop-releases.cdn.actuar.cloud/EdgeDesk/EdgeDesk.appinstaller',
  access_desk_release:
    'https://prd-desktop-releases.cdn.actuar.cloud/AccessDesk/AccessDesk.appinstaller',
  print_agent_release:
    'https://prd-desktop-releases.cdn.actuar.cloud/PrintAgent/PrintAgent.appinstaller',
  odata: prefix + 'odata.stg.g.actuar.cloud',
  odata_goods_service: prefix + 'goodservice-api.stg.g.actuar.cloud/Odata',
  odata_person_service: prefix + 'personservice-api.stg.g.actuar.cloud/Odata',
  odata_payable_service: prefix + 'payableservice-api.stg.g.actuar.cloud/Odata',
  odata_work_service: prefix + 'workservice-api.stg.g.actuar.cloud/Odata',
  odata_crm_service: prefix + 'crmservice-api.stg.g.actuar.cloud/Odata',
  odata_generalfinance_service:
    prefix + 'generalfinanceservice-api.stg.g.actuar.cloud/Odata',
  odata_account_service: prefix + 'accountservice-api.stg.g.actuar.cloud/Odata',
  odata_receivable_service:
    prefix + 'receivableservice-api.stg.g.actuar.cloud/Odata',
  odata_email_service: prefix + 'emailservice-api.stg.g.actuar.cloud/Odata',
  odata_contract: prefix + 'contractservice-api.stg.g.actuar.cloud/Odata',
  odata_user_service: prefix + 'userservice-api.stg.g.actuar.cloud/Odata',
  odata_workout_service: prefix + 'workoutservice-api.stg.g.actuar.cloud/Odata',
  odata_post_service: prefix + 'postservice-api.stg.g.actuar.cloud/Odata',
  odata_activity_service:
    prefix + 'activityservice-api.stg.g.actuar.cloud/Odata',
  odata_addresses_service:
    prefix + 'addressservice-api.stg.g.actuar.cloud/Odata',
  odata_booking_service: prefix + 'bookingservice-api.stg.g.actuar.cloud/Odata',
  odata_graduation_service:
    prefix + 'graduationservice-api.stg.g.actuar.cloud/Odata',
  odata_data_service: prefix + 'dataservice-api.stg.g.actuar.cloud/Odata',
  odata_subscription_service:
    prefix + 'subscriptionservice-api.stg.g.actuar.cloud/Odata',
  odata_physical_assessment_service:
    prefix + 'physicalassessmentservice-api.stg.g.actuar.cloud/Odata',
  odata_helpdesk_service:
    prefix + 'helpdeskservice-api.stg.g.actuar.cloud/Odata',
  odata_hotsite_service: prefix + 'hotsiteservice-api.stg.g.actuar.cloud/Odata',
  odata_consumption_log_service:
    prefix + 'consumptionlogservice-api.stg.g.actuar.cloud/Odata',
  odata_access_log_service:
    prefix + 'accesslogservice-api.stg.g.toletus.cloud/Odata',
  odata_filegroup_service:
    prefix + 'filegroupservice-api.stg.g.actuar.cloud/Odata',
  odata_access_service: prefix + 'accessservice-api.stg.g.actuar.cloud/Odata',
  odata_access_flow_service:
    prefix + 'accessflowservice-api.stg.g.toletus.cloud/Odata',
  odata_access_directory_service:
    prefix + 'accessdirectoryservice-api.stg.g.toletus.cloud/Odata',
  odata_school_service: prefix + 'schoolservice-api.stg.g.actuar.cloud/Odata',
  school_service: prefix + 'schoolservice-api.stg.g.actuar.cloud',
  base: prefix + 'actuar-api.stg.g.actuar.cloud',
  paguela: prefix + 'paguela-api.stg.g.actuar.cloud',
  api_cep: prefix + 'cep-api.stg.g.actuar.cloud',
  auth: prefix + 'authentication-api.stg.g.actuar.cloud',
  chat: prefix + 'chat-api.stg.g.actuar.cloud',
  file_manager: prefix + 'filegroup-api.stg.g.actuar.cloud',
  treino: prefix + 'treino-api.stg.g.actuar.cloud',
  facial: prefix + 'facial-api.stg.g.actuar.cloud',
  acesso: prefix + 'acesso-api.stg.g.actuar.cloud',
  caixa: prefix + 'caixa-api.stg.g.actuar.cloud',
  treasury_service: prefix + 'treasuryservice-api.stg.g.actuar.cloud',
  helpdesk: prefix + 'helpdeskservice-api.stg.g.actuar.cloud',
  ajustes: prefix + 'tst.actuar.net/actuar',
  files_api: prefix + 'files-api.stg.g.actuar.cloud',
  contract: prefix + 'contractservice-api.stg.g.actuar.cloud',
  billing: prefix + 'billing-api.stg.g.actuar.cloud',
  gympass: prefix + 'gympass-api.stg.g.actuar.cloud',
  client_notification: prefix + 'clientnotification-api.stg.g.actuar.cloud',
  client_device: prefix + 'clientdeviceservice-api.stg.g.actuar.cloud',
  invoicer: prefix + 'invoicer-api.stg.g.actuar.cloud',
  acessoLocalhost: Protocol.http + 'localhost:63312',
  userService: prefix + 'userservice-api.stg.g.actuar.cloud',
  personService: prefix + 'personservice-api.stg.g.actuar.cloud',
  file_group: prefix + 'filegroup-api.stg.g.actuar.cloud',
  account_service: prefix + 'accountservice-api.stg.g.actuar.cloud',
  goods: prefix + 'goodservice-api.stg.g.actuar.cloud',
  payable_service: prefix + 'payableservice-api.stg.g.actuar.cloud',
  workService: prefix + 'workservice-api.stg.g.actuar.cloud',
  crm_service: prefix + 'crmservice-api.stg.g.actuar.cloud',
  generalfinance_service:
    prefix + 'generalfinanceservice-api.stg.g.actuar.cloud',
  receivable_service: prefix + 'receivableservice-api.stg.g.actuar.cloud',
  subscription_service: prefix + 'subscriptionservice-api.stg.g.actuar.cloud',
  email_service: prefix + 'emailservice-api.stg.g.actuar.cloud',
  workout_service: prefix + 'workoutservice-api.stg.g.actuar.cloud',
  workout_view: prefix + 'workoutviewservice-api.stg.g.actuar.cloud',
  post_service: prefix + 'postservice-api.stg.g.actuar.cloud',
  activity_service: prefix + 'activityservice-api.stg.g.actuar.cloud',
  activity_tracking_service: prefix + 'activitytrackingservice-api.stg.g.actuar.cloud',
  booking_service: prefix + 'bookingservice-api.stg.g.actuar.cloud',
  data_service: prefix + 'dataservice-api.stg.g.actuar.cloud',
  addresses_service: prefix + 'addressservice-api.stg.g.actuar.cloud',
  storage_service: 'https://storageservice-api.stg.g.actuar.cloud',
  physical_assessment_service:
    prefix + 'physicalassessmentservice-api.stg.g.actuar.cloud',
  whatsapp_service: prefix + 'whatsappservice-api.stg.g.actuar.cloud',
  graduation_service: prefix + 'graduationservice-api.stg.g.actuar.cloud',
  totalpass: prefix + 'totalpassservice-api.stg.g.actuar.cloud',
  hotsite: prefix + 'hotsite-api.stg.g.actuar.cloud',
  storage: prefix + 'storage-api.stg.g.actuar.cloud',
  search_service: prefix + 'searchservice-api.prd.g.actuar.cloud',
  file_group_service: prefix + 'filegroupservice-api.stg.g.actuar.cloud',
  hotsite_service: prefix + 'hotsiteservice-api.stg.g.actuar.cloud',
  credit_assessment_service:
    prefix + 'creditassessmentservice-api.stg.g.actuar.cloud',
  meetings_service: prefix + 'meetingservice-api.stg.g.actuar.cloud',
  access_service: prefix + 'accessservice-api.stg.g.actuar.cloud',
  access_directory_service:
    prefix + 'accessdirectoryservice-api.stg.g.toletus.cloud',
  consumption_log_service:
    prefix + 'consumptionlogservice-api.stg.g.actuar.cloud',
  consumption_auth_service:
    prefix + 'consumptionauthservice-api.stg.g.actuar.cloud',
  access_edge_manager_service:
    prefix + 'accessedgemanager-api.prd.o.toletus.cloud',
  access_edge_manager_service_grpc:
    prefix + 'grpc.accessedgemanager-api.prd.o.toletus.cloud',
  fingerprint_service: prefix + 'fingerprintservice-api.prd.g.toletus.cloud',
  suggestion_service: prefix + 'suggestionservice-api.prd.cfw.actuar.cloud',
  registration_service: prefix + 'registrationservice-api.prd.cfw.actuar.cloud',
  // weatherservice-api tem deploy unico (producao): o handoff declara que nao ha
  // ambiente de homologacao separado, entao todos os ambientes apontam para o mesmo
  // host — como print_agent_service e suggestion_service. Quando houver stg, o lugar
  // de separar e aqui: o front nunca monta esta URL a mao.
  weather_service: prefix + 'weatherservice-api.prd.o.actuar.cloud',
  academy_service: prefix + 'academyservice-api.stg.g.actuar.cloud',
  odata_academy_service: prefix + 'academyservice-api.stg.g.actuar.cloud/odata',
  migrator_service: prefix + 'migrator-api.stg.g.actuar.cloud',
  spooler: prefix + 'spooler-api.stg.g.actuar.cloud',
  print_agent_service: prefix + 'printagentservice-api.prd.g.toletus.cloud',
  access_edge_provisioning_service:
    prefix + 'accessedgeprovisioning-api.prd.g.toletus.cloud',
  // ChannelGateway tem deploy único (produção): dev e stg não expõem ingress
  // (helm-gke/dev-values.yaml -> `ingress.enabled: false`, sem route/gateway),
  // então todos os ambientes apontam para o mesmo host — como print_agent_service.
  channel_gateway_service: prefix + 'channelgateway-api.prd.g.actuar.cloud',
  odata_channel_gateway_service:
    prefix + 'channelgateway-api.prd.g.actuar.cloud/OData',
  support_service: prefix + 'supportservice-api.prd.o.actuar.cloud',
  ato_service: prefix + 'atoservice-api.prd.o.actuar.cloud',
  access_log_service: prefix + 'accesslogservice-api.stg.g.toletus.cloud',
  access_flow_service: prefix + 'accessflowservice-api.stg.g.toletus.cloud',
  integration_api: prefix + 'api.actuar.com',
  linkbio_service: prefix + 'linkbioworker-api.prd.cfw.actuar.cloud',
  geo_service: prefix + 'geoworker-api.prd.cfw.actuar.cloud',
  // Comunicados — Worker Cloudflare do repo Actuar/announcementsworker-api.
  // MESMA URL nos cinco ambientes: o Worker tem publicacao unica em producao
  // (ADR 0004 de la), sem par de stg/prd. Quando houver, o lugar de separar e
  // aqui — o front nunca monta esta URL a mao.
  announcements_service: prefix + 'announcementsworker-api.prd.cfw.actuar.cloud',
  access_scheduling_service: prefix + 'schedulertoletusapi-worker.dev5014.workers.dev',
  print_scheduling_service: prefix + 'schedulerprintagentapi-worker.dev5014.workers.dev',
  // Worker Cloudflare do programa de indicacoes (repo Actuar/indicationsapi-worker).
  // MESMA URL nos cinco ambientes: o Worker e um so, sem par de stg/prd. Quando houver, o lugar
  // de separar e aqui — o front nunca monta esta URL a mao.
  // Dominio proprio `prd.cfw`, no formato do `suggestion_service`, em vez do `workers.dev` gerado.
  indications_service: prefix + 'indicationsworker-api.prd.cfw.actuar.cloud',
};
